export const SUBMIT_BTN = 'submit-btn';
export const CANCEL_BTN = 'cancel-btn';
